import { render, staticRenderFns } from "./AtomCheckboxPrimary.vue?vue&type=template&id=f969d2e2&"
import script from "./AtomCheckboxPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomCheckboxPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports